export class InformationFields {
    public static AssemblySignature = "AssemblySignature";
    public static ActivityInstanceId = "ActivityInstanceId";
    public static ActivityType = "ActivityType";
    public static AssignedTo = "AssignedTo";
    public static Author = "Author";
    public static ChangesetId = "ChangesetId";
    public static ChangesetUri = "ChangesetUri";
    public static CheckedInBy = "CheckedInBy";
    public static CheckInCommitted = "CheckInCommitted";
    public static Code = "Code";
    public static Comment = "Comment";
    public static CommitId = "CommitId";
    public static Committer = "Committer";
    public static CompilationErrors = "CompilationErrors";
    public static CompilationWarnings = "CompilationWarnings";
    public static ContextId = "ContextId";
    public static DisplayText = "DisplayText";
    public static EndLineNumber = "EndLineNumber";
    public static ErrorType = "ErrorType";
    public static File = "File";
    public static FinishTime = "FinishTime";
    public static Flavor = "Flavor";
    public static GitUri = "GitUri";
    public static Importance = "Importance";
    public static LineNumber = "LineNumber";
    public static LocalPath = "LocalPath";
    public static LogFile = "LogFile";
    public static Message = "Message";
    public static Name = "Name";
    public static NumBytes = "NumBytes";
    public static NumFiles = "NumFiles";
    public static OriginalName = "OriginalName";
    public static Owner = "Owner";
    public static OriginalOwner = "OriginalOwner";
    public static Platform = "Platform";
    public static PossibleAgents = "PossibleAgents";
    public static ProjectFile = "ProjectFile";
    public static Properties = "Properties";
    public static QualifiedName = "QualifiedName";
    public static RelativeServerLogDirectory = "RelativeServerLogDirectory";
    public static RequestId = "RequestId";
    public static RequestedBy = "RequestedBy";
    public static ReservationStatus = "ReservationStatus";
    public static ReservedAgentName = "ReservedAgentName";
    public static ReservedAgentUri = "ReservedAgentUri";
    public static SectionHeader = "SectionHeader";
    public static SectionName = "SectionName";
    public static SectionPriority = "SectionPriority";
    public static ServerPath = "ServerPath";
    public static StartTime = "StartTime";
    public static State = "State";
    public static StaticAnalysisErrors = "StaticAnalysisErrors";
    public static StaticAnalysisWarnings = "StaticAnalysisWarnings";
    public static Status = "Status";
    public static TargetNames = "TargetNames";
    public static Timestamp = "Timestamp";
    public static TotalCompilationErrors = "TotalCompilationErrors";
    public static TotalCompilationWarnings = "TotalCompilationWarnings";
    public static TotalStaticAnalysisErrors = "TotalStaticAnalysisErrors";
    public static TotalStaticAnalysisWarnings = "TotalStaticAnalysisWarnings";
    public static Title = "Title";
    public static Uri = "Uri";
    public static Url = "Url";
    public static WarningType = "WarningType";
    public static WorkItemId = "WorkItemId";
    public static WorkItemUri = "WorkItemUri";
    public static DeploymentInformationType = "DeploymentInformationType";
    constructor() {
    }
}

export class InformationTypes {
    public static ActivityProperties: string = "ActivityProperties";
    public static ActivityTracking: string = "ActivityTracking";
    public static AgentScopeActivityTracking: string = "AgentScopeActivityTracking";
    public static AssociatedChangeset: string = "AssociatedChangeset";
    public static AssociatedCommit: string = "AssociatedCommit";
    public static AssociatedWorkItem: string = "AssociatedWorkItem";
    public static BuildError: string = "BuildError";
    public static BuildMessage: string = "BuildMessage";
    public static BuildProject: string = "BuildProject";
    public static BuildStep: string = "BuildStep";
    public static BuildWarning: string = "BuildWarning";
    public static CheckInOutcome: string = "CheckInOutcome";
    public static CompilationSummary: string = "CompilationSummary";
    public static ConfigurationSummary: string = "ConfigurationSummary";
    public static DeploymentInformation: string = "DeploymentInformation";
    public static ExternalLink: string = "ExternalLink";
    public static OpenedWorkItem: string = "OpenedWorkItem";
    public static ReshelvedShelveset: string = "ReshelvedShelveset";
    public static RunOnceState: string = "RunOnceState";
    public static SymStoreTransaction: string = "SymStoreTransaction";
    public static CodeCoverageSummary: string = "CodeCoverageSummary";
    public static TestImpact: string = "TestImpact";
    public static TestSummary: string = "TestSummary";
    public static IntermediateLogInformation: string = "IntermediateLogInformation";
    public static CustomSummaryInformation: string = "CustomSummaryInformation";

    constructor() {
    }
}